import { render, staticRenderFns } from "./lyric.vue?vue&type=template&id=e22ee442&scoped=true&"
import script from "./lyric.vue?vue&type=script&lang=js&"
export * from "./lyric.vue?vue&type=script&lang=js&"
import style0 from "./lyric.vue?vue&type=style&index=0&id=e22ee442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ee442",
  null
  
)

export default component.exports